import { englishDomTheme } from "./theme.config.js";
const assetBase = "/assets/quizzes/englishdom";
const sharedDemoAssets = "/assets/quizzes/demo";
export const englishDomQuiz = {
    id: "englishdom-real-observations",
    slug: "englishdom",
    version: 1,
    presentation: {
        style: "expressive",
        flowLayout: "compact",
        firstQuestionLayout: "portrait-pair",
        entryComposition: "compact-cluster",
        portraitCrops: {
            female: { scale: 1.03, objectPosition: "50% 0%", offsetY: "1.5%", transformOrigin: "50% 0%", background: "#ddddfa" },
            male: { scale: 1, objectPosition: "50% 0%", background: "#ffd8be" }
        },
        counter: { enabled: true, totalSteps: 5, excludeQuestionIds: ["gender"] },
        resultGate: "compact",
        analysisVisual: {
            type: "animated-image",
            src: `${assetBase}/cat-wheel.webp`,
            reducedMotionSrc: `${assetBase}/cat-wheel-still.webp`,
            width: 400,
            height: 225,
            alt: "",
            crop: "contain",
            motion: "none",
            placement: "heading-above",
            shape: "rounded"
        }
    },
    metadata: {
        name: "EnglishDom",
        language: "uk",
        description: "Observation-based EnglishDom quiz built from the provided DOCX content."
    },
    startQuestionId: "gender",
    landing: { enabled: false, sections: [] },
    start: {
        enabled: true,
        renderer: "native",
        mode: "first-question",
        layout: "split-question",
        eyebrow: "5 ситуацій · приблизно 2 хвилини",
        title: "Як твоя англійська\nпрацює в житті?",
        subtitle: "5 коротких ситуацій без правильних і неправильних відповідей. Наприкінці — персональний розбір твоєї англійської.",
        cta: { label: "Почати тест", action: "startQuiz" },
        background: { type: "color", value: "#4FC87B" },
        logo: { enabled: true, src: `${assetBase}/logo-white.png`, alt: "EnglishDom" }
    },
    progress: {
        mode: "stages",
        stages: [
            { id: "entry", weight: 0 },
            { id: "situation-1", weight: 20 },
            { id: "situation-2", weight: 20 },
            { id: "situation-3", weight: 20 },
            { id: "situation-4", weight: 20 },
            { id: "situation-5", weight: 20 }
        ]
    },
    phone: {
        defaultCountry: "UA",
        preferredCountries: ["UA", "CZ", "PL", "DE"],
        searchable: true
    },
    questions: [
        {
            id: "gender",
            type: "single-choice",
            stage: "entry",
            title: "Обери стать",
            answers: [
                { id: "female", label: "Жінка", media: { src: `${assetBase}/woman-v7.png`, alt: "" }, next: "tourist_directions", scores: {} },
                { id: "male", label: "Чоловік", media: { src: `${sharedDemoAssets}/answers/man-v4.webp`, alt: "" }, next: "tourist_directions", scores: {} }
            ]
        },
        {
            id: "tourist_directions",
            type: "single-choice",
            stage: "situation-1",
            title: "Уяви: до тебе підходить турист і англійською питає, як кудись пройти. Що станеться найімовірніше?",
            answers: [
                {
                    id: "explain_anyway",
                    label: "Поясню як зможу. Якщо що - жестами теж можна",
                    next: "english_in_life",
                    scores: {},
                    resultObservation: {
                        male: "Ти вже готовий говорити, навіть без ідеальних речень. Це сильніша база, ніж може здаватися.",
                        female: "Ти вже готова говорити, навіть без ідеальних речень. Це сильніша база, ніж може здаватися."
                    }
                },
                {
                    id: "build_phrase_slowly",
                    label: "Зрозумію, але фразу збиратиму по шматочках",
                    next: "english_in_life",
                    scores: {},
                    resultObservation: "Схоже, англійська в голові є - просто їй поки не вистачає швидкості на виході."
                },
                {
                    id: "words_disappear",
                    label: "Слова знаю, поки не треба сказати їх прямо зараз",
                    next: "english_in_life",
                    scores: {},
                    resultObservation: "Потрібні слова в тебе є, але в живій розмові вони іноді ховаються саме в потрібний момент."
                },
                {
                    id: "grammar_freeze",
                    label: "Почну будувати правильну фразу й зависну на граматиці",
                    next: "english_in_life",
                    scores: {},
                    resultObservation: "Тебе гальмує не лише знання мови, а й бажання сказати все правильно з першої спроби."
                },
                {
                    id: "dont_understand",
                    label: "Скоріш за все, спочатку не розберу, що сказали",
                    next: "english_in_life",
                    scores: {},
                    resultObservation: "Найскладніше зараз - швидко розібрати живу англійську на слух. І це навичка, яку можна натренувати."
                }
            ]
        },
        {
            id: "english_in_life",
            type: "single-choice",
            stage: "situation-2",
            title: "А де англійська реально з'являється у твоєму житті зараз?",
            answers: [
                {
                    id: "apps_exercises",
                    label: "Вчу слова або роблю вправи в застосунку",
                    next: "fast_conversation",
                    scores: {},
                    resultObservation: "Англійська вже є у твоєму житті, але поки переважно в безпечному форматі вправ і застосунків."
                },
                {
                    id: "sometimes_speak",
                    label: "Іноді говорю англійською з людьми",
                    next: "fast_conversation",
                    scores: {},
                    resultObservation: "У тебе вже був досвід живої англійської - тобто розмова цією мовою для тебе не зовсім чужа."
                },
                {
                    id: "watch_listen",
                    label: "Дивлюся серіали, YouTube або слухаю подкасти",
                    next: "fast_conversation",
                    scores: {},
                    resultObservation: "Ти даєш англійській багато звучати поруч, але поки даєш собі менше можливостей відповідати."
                },
                {
                    id: "understand_and_speak",
                    label: "І слухаю, і говорю - англійська вже потрібна мені в житті",
                    next: "fast_conversation",
                    scores: {},
                    resultObservation: "Англійська вже стала частиною твого життя. Наступний крок - зробити її більш вільною й звичною."
                },
                {
                    id: "almost_nowhere",
                    label: "Якщо чесно - майже ніде",
                    next: "fast_conversation",
                    scores: {},
                    resultObservation: "Схоже, англійська поки просто чекає свого місця у твоєму житті - і почати можна без різкого занурення."
                }
            ]
        },
        {
            id: "fast_conversation",
            type: "single-choice",
            stage: "situation-3",
            title: "Уяви: вмикаєш відео, де двоє людей швидко говорять англійською. Що відбувається з тобою?",
            answers: [
                {
                    id: "understand_almost_all",
                    label: "Розумію майже все - навіть жарти",
                    next: "speaking_barrier",
                    scores: {},
                    resultObservation: "Ти добре тримаєш живу англійську на слух. Тепер це можна сміливіше переносити в розмову."
                },
                {
                    id: "main_idea_only",
                    label: "Загальний сенс ловлю, але деталі губляться",
                    next: "speaking_barrier",
                    scores: {},
                    resultObservation: "Загальний сенс ти вже ловиш; наступний крок - перестати випадати з розмови через окремі незнайомі деталі."
                },
                {
                    id: "separate_words",
                    label: "Чіпляю окремі слова й здогадуюся про решту",
                    next: "speaking_barrier",
                    scores: {},
                    resultObservation: "Твій слух уже чіпляється за знайоме. Тепер йому бракує трохи більше цілісності й звички до живої швидкості."
                },
                {
                    id: "lose_thread",
                    label: "Через хвилину вже перестаю розуміти, що відбувається",
                    next: "speaking_barrier",
                    scores: {},
                    resultObservation: "Швидка жива англійська поки звучить суцільним потоком. Це не відсутність здібностей, а окрема навичка."
                }
            ]
        },
        {
            id: "speaking_barrier",
            type: "single-choice",
            stage: "situation-4",
            title: "Треба відповісти англійською прямо зараз. Що стопорить найбільше?",
            answers: [
                {
                    id: "fear_mistake",
                    label: "Найважче просто почати - боюся помилитися",
                    next: "english_without_tension",
                    scores: {},
                    resultObservation: "Тебе більше стримує момент старту, ніж сама англійська. Коли цей бар'єр зменшується, говорити стає значно легше."
                },
                {
                    id: "recall_words",
                    label: "Потрібні слова приходять у голову занадто повільно",
                    next: "english_without_tension",
                    scores: {},
                    resultObservation: "Найбільше хочеться, щоб слова приходили самі - без довгого внутрішнього пошуку."
                },
                {
                    id: "translate_in_head",
                    label: "Перекладаю кожне речення в голові, перш ніж сказати",
                    next: "english_without_tension",
                    scores: {},
                    resultObservation: "Ти ще часто йдеш до англійської фрази через переклад. Більше автоматизму помітно полегшить розмову."
                },
                {
                    id: "understand_reply",
                    label: "Боюся не зрозуміти, що мені скажуть у відповідь",
                    next: "english_without_tension",
                    scores: {},
                    resultObservation: {
                        male: "Для впевненості тобі особливо важливо навчитися не випадати з розмови, навіть якщо щось не розчув.",
                        female: "Для впевненості тобі особливо важливо навчитися не випадати з розмови, навіть якщо щось не розчула."
                    }
                },
                {
                    id: "want_more_fluency",
                    label: "Загалом говорю нормально - просто хочу робити це вільніше",
                    next: "english_without_tension",
                    scores: {},
                    resultObservation: "База вже є. Тепер хочеться менше внутрішнього контролю й більше легкості в живій розмові."
                }
            ]
        },
        {
            id: "english_without_tension",
            type: "single-choice",
            stage: "situation-5",
            title: "Уяви, що завтра англійська раптом стала легкою. Що зробиш насамперед?",
            answers: [
                {
                    id: "talk_foreigner",
                    label: "Спокійно підтримувати розмову з іноземцем",
                    next: "__end__",
                    scores: {},
                    resultObservation: "Тобі важливо не просто знати англійську, а не губитися поруч із живою людиною."
                },
                {
                    id: "movies_without_subtitles",
                    label: "Дивитися фільми й відео без субтитрів",
                    next: "__end__",
                    scores: {},
                    resultObservation: "Тобі хочеться менше перекладати в голові й більше просто бути всередині історії."
                },
                {
                    id: "use_at_work",
                    label: "Використовувати її в роботі без постійного стресу",
                    next: "__end__",
                    scores: {},
                    resultObservation: "Англійська для тебе може бути не предметом для вивчення, а практичним інструментом для роботи й нових можливостей."
                },
                {
                    id: "travel_independently",
                    label: "Подорожувати й вирішувати все самостійно",
                    next: "__end__",
                    scores: {},
                    resultObservation: "Тобі хочеться почуватися вільніше в іншій країні - без пошуку перекладача в кожній новій ситуації."
                },
                {
                    id: "speak_without_fear",
                    label: "Просто говорити й не думати постійно про помилки",
                    next: "__end__",
                    scores: {},
                    resultObservation: "Найбільше тобі потрібен не ідеальний акцент, а спокій і сміливість говорити."
                }
            ]
        }
    ],
    scoring: {
        categories: []
    },
    results: [],
    personalizedResult: {
        mode: "answer-observations",
        genderQuestionId: "gender",
        intro: "Схоже, твоя англійська вже має на що спертися. Ось що ми побачили:",
        lockedTitle: "Твій персональний розбір готовий",
        unlockedTitle: "Ось що ми побачили у твоїй англійській",
        lockedText: "Залиш контакти, щоб відкрити всі 5 спостережень.",
        outro: "На безкоштовному вступному уроці можна спокійно перевірити, що вже виходить, і зрозуміти, що допоможе тобі заговорити вільніше."
    },
    analysis: {
        title: "Збираємо картину твоєї англійської",
        subtitle: "Зіставляємо твої відповіді та готуємо персональний розбір.",
        display: "stage-cards",
        durationMs: 3900,
        reducedMotionDurationMs: 400,
        steps: [
            { id: "answers", title: "Аналізуємо відповіді" },
            { id: "picture", title: "Збираємо картину англійської" },
            { id: "result", title: "Готуємо персональний розбір" }
        ],
        checkpoints: [0, 17, 34, 41, 63, 82, 96, 100]
    },
    resultPresentation: {
        visual: { type: "image", src: `${assetBase}/secret-envelope.webp`, width: 384, height: 384, alt: "", crop: "cover", motion: "none", placement: "heading", size: "small", align: "center" }
    },
    leadForm: {
        title: "Відкрий свій розбір",
        subtitle: "Залиш контакти, щоб отримати доступ.",
        placement: "inline-result",
        fields: {
            name: { enabled: true, required: true, label: "Ім'я" },
            phone: { enabled: true, required: true, label: "Телефон" },
            email: { enabled: true, required: true, label: "Електронна пошта" }
        },
        privacyConsentRequired: true,
        marketingConsentEnabled: true,
        submitLabel: "Відкрити мій розбір"
    },
    integrations: {
        googleSheets: {
            enabled: true
        }
    },
    uiCopy: {
        resultEyebrow: "Персональний розбір",
        lockedTitle: "Твій персональний розбір готовий",
        lockedText: "Залиш контакти, щоб відкрити всі 5 спостережень.",
        fullResultTitle: "Повний розбір",
        resultCta: "Відкрити розбір",
        leadSaved: "Заявку збережено"
    },
    theme: englishDomTheme
};
